import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { initMetaPixel, trackPageView } from "@/lib/metaPixel";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Guide from "@/pages/Guide";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import AppLayout from "@/layouts/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import ImportPage from "@/pages/ImportPage";
import CreateInvoice from "@/pages/CreateInvoice";
import Settings from "@/pages/Settings";
import SubscriptionPage from "@/pages/SubscriptionPage";

function AppRouter() {
  const location = useLocation();
  useEffect(() => { initMetaPixel(); }, []);
  useEffect(() => { trackPageView(); }, [location.pathname]);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/guide" element={<Guide />} />
      <Route path="/connexion" element={<Login />} />
      <Route path="/reinitialiser-mot-de-passe" element={<ResetPassword />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="factures" element={<Invoices />} />
        <Route path="factures/nouvelle" element={<CreateInvoice />} />
        <Route path="factures/:id" element={<InvoiceDetail />} />
        <Route path="importer" element={<ImportPage />} />
        <Route path="abonnement" element={<SubscriptionPage />} />
        <Route path="parametres" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
